import { render } from "./facebookGeneral.vue?vue&type=template&id=d68f1a84"
import script from "./facebookGeneral.vue?vue&type=script&lang=js"
export * from "./facebookGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__